import React from 'react';
import AdminLayout from '../../components/AdminLayout';

const AdminSettings = () => {
  return (
    <AdminLayout>
      <div className="mb-8">
        <h1 className="font-playfair text-4xl font-bold mb-2">Settings</h1>
        <p className="font-manrope text-sm text-gray-600">Configure platform settings</p>
      </div>

      <div className="border border-gray-200 p-8 bg-white">
        <h2 className="font-playfair text-2xl font-bold mb-4">Platform Configuration</h2>
        <p className="font-manrope text-sm text-gray-600 mb-6">
          Settings page coming soon. Configure payment gateways, email templates, and system preferences.
        </p>
        
        <div className="space-y-4">
          <div className="p-4 border border-gray-200">
            <h3 className="font-manrope font-semibold text-sm mb-2">Payment Settings</h3>
            <p className="font-manrope text-xs text-gray-600">Razorpay API keys, webhook configuration</p>
          </div>
          
          <div className="p-4 border border-gray-200">
            <h3 className="font-manrope font-semibold text-sm mb-2">Email Configuration</h3>
            <p className="font-manrope text-xs text-gray-600">SMTP settings, notification templates</p>
          </div>
          
          <div className="p-4 border border-gray-200">
            <h3 className="font-manrope font-semibold text-sm mb-2">GST & Invoice</h3>
            <p className="font-manrope text-xs text-gray-600">Company details, GST number, invoice templates</p>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminSettings;